import { render, staticRenderFns } from "./ModalCadastroFornecedores.vue?vue&type=template&id=ab902744&"
import script from "./ModalCadastroFornecedores.vue?vue&type=script&lang=js&"
export * from "./ModalCadastroFornecedores.vue?vue&type=script&lang=js&"
import style0 from "./ModalCadastroFornecedores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports